const filters = {
  and: [
    {
      or: [
        {
          and: [
            {
              filterID: 7,
              isNegated: false,
              inputs: {
                searchTerm: "Admin",
              },
            },
          ],
        },
      ],
    },
  ],
};

export const getReportTemplates = {
  success: true,
  isApp: false,
  templates: [
    {
      boardID: 1,
      title: "Test Template 1",
      description:
        "Anim minim eu ad incididunt commodo commodo cillum quis id proident eiusmod quis nostrud.",
      icon: "fa-starfighter-alt",
      disabled: false,
    },
    {
      boardID: 2,
      title: "Test Template 2",
      description:
        "Anim minim eu ad incididunt commodo commodo cillum quis id proident eiusmod quis nostrud.",
      icon: "fa-starship-freighter",
      disabled: false,
    },
    {
      boardID: 3,
      title: "Test Template 3",
      description:
        "Anim minim eu ad incididunt commodo commodo cillum quis id proident eiusmod quis nostrud.",
      icon: "fa-space-station-moon-alt",
      disabled: false,
    },
    {
      boardID: 4,
      title: "Test Template 4",
      description:
        "Anim minim eu ad incididunt commodo commodo cillum quis id proident eiusmod quis nostrud. <a href='google.com' target='_blank'>A LINK</a>",
      icon: "fa-jedi",
      disabled: true,
    },
  ],
};
